import React from 'react';
import { bool } from 'prop-types';
import { Loader } from '@thd-olt-component-react/core-ui';
import * as styles from './loading.module.scss';

export const Loading = ({ active }) => (
  <div className={styles.loadingContainer}>
    <Loader active={active} />
  </div>
);

Loading.propTypes = {
  active: bool
};

Loading.defaultProps = {
  active: false
};